import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';

import { Main, Filter } from 'Containers';
import { LoadingPage, DirtyWrapper } from 'Components';
import {
  NewEditUsageEnum,
  StatusOptionEnum,
  SiteStatusEnum,
} from 'Common/Constants/Enumeration/UsageListEnum';
import {
  BidGroupEnum,
  CreateEditUsageEnum,
  FilterEnum,
} from 'Common/FieldEnum';
import {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
} from 'State/filters/actions';
import { CREATE_EDIT_USAGE_FORM_NAME } from 'Common/FormEnum';
import { submitForm, resetForm, destroyForm } from 'State/forms/actions';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import * as FilterSelectors from 'State/filters/selectors';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { resetDirty } from 'State/dirtyTracking/actions';

import { CreateEditUsage } from '../../containers/createEditUsage/CreateEditUsage';
import { PreviewUsage } from '../createEditUsage/PreviewUsage';
import { getUsageDetail } from './../../state/CreateEditUsage/actions';
import {
  clearInvalidPreviewData,
  resetFilterOnClickOfPreviousPage,
  clearOrderSubmitError,
} from './../../state/CreateEditUsage/actions';
import {
  emptyItemList,
  emptyEditDulObject,
  saveUsage,
  getUsageItems,
} from './../../state/CreateEditUsage/actions';
import { basicURL, getSaveObject } from '../../helper';
import * as Selectors from '../../state/CreateEditUsage/selectors';

class CreateEditUsageWizardForm extends Component {
  static propTypes = {
    usageItemsInfo: PropTypes.array,
    usageDT: PropTypes.string,

    isDisabled: PropTypes.bool,
    allTableStates: PropTypes.object.isRequired,
    usageItems: PropTypes.array.isRequired,
    fetchUsageItems: PropTypes.bool.isRequired,
    fetchingUsageDetail: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    fetchUsageDetailError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    usageItemsLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    selectedUsageDetail: PropTypes.object,
    loading: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    usageItemsInfo: [],
    usageDT: moment().format(DATE_FORMAT_FOR_UI),
    submitError: null,
    fetchUsageDetailError: null,
    usageItemsLoadingError: null,
    selectedUsageDetail: null,
    isDisabled: false,
  };
  static path = '/usage/:IsNewEdit/:UsageId';
  state = {
    page: 1,
    OpType: 'S',
    showDeliveryDateModal: false,
    values: null,
    resetPageOnDataChange: true,
  };

  componentDidMount() {
    const { IsNewEdit, UsageId } = this.props.match.params;
    const {
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getUsageDetail,
      getUsageItems,
    } = this.props;

    getBidGroupForCurrentSite(BidGroupEnum.UnassignedAndAll);
    getItemGroupForCurrentSite();

    if (IsNewEdit !== NewEditUsageEnum.NEW) {
      getUsageDetail(UsageId).then(() => {
        const { selectedUsageDetail } = this.props;
        if (selectedUsageDetail) {
          const filtersOptions = {
            SiteId: selectedUsageDetail[CreateEditUsageEnum.SiteId],
            DateUsage: moment(
              selectedUsageDetail[CreateEditUsageEnum.UsageDT]
            ).format(DATE_FORMAT_FOR_SERVER),
          };
          if (!this.props.isDisabled) {
            getUsageItems(
              filtersOptions,
              true,
              selectedUsageDetail[CreateEditUsageEnum.UsageItems]
            );
          }
        }
      });
    }
    this.props.resetDirty();
  }

  componentDidUpdate(prevProps) {
    const { clearOrderSubmitError, emptyItemList } = this.props;

    if (
      errorToast(this.props, prevProps, 'fetchUsageDetailError') ||
      errorToast(this.props, prevProps, 'submitError')
    ) {
      clearOrderSubmitError();
    } else if (errorToast(this.props, prevProps, 'usageItemsLoadingError')) {
      clearOrderSubmitError();
      emptyItemList();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(toastType.success, 'Success', 'Usage has been saved', true);
      clearOrderSubmitError();
    }
  }

  componentWillUnmount() {
    const {
      emptyItemList,
      selectedUsageDetail,
      emptyEditDulObject,
    } = this.props;
    this.completeReset();
    emptyItemList();
    if (selectedUsageDetail) {
      emptyEditDulObject();
    }
    this.clearTableSavedState();
  }
  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.USAGE_LIST_TABLE,
      TableNamesEnum.USAGE_LIST_CREATE_EDIT_TABLE,
    ]);
  };

  completeReset = () => {
    this.props.resetForm(CREATE_EDIT_USAGE_FORM_NAME);
    this.props.destroyForm(CREATE_EDIT_USAGE_FORM_NAME);
  };

  getBreadCrumbs = () => {
    const { page } = this.state;
    const { IsNewEdit } = this.props.match.params;
    const { isDisabled } = this.props;
    let breadcrumbs = [
      {
        title: 'Usage',
        link: '/usage',
      },
      {
        title:
          IsNewEdit !== NewEditUsageEnum.EDIT
            ? 'Create New'
            : isDisabled
              ? 'View'
              : 'Edit',
        link: '',
      },
    ];
    if (page === 1) {
      breadcrumbs[1].link = '';
    }
    if (page === 2) {
      breadcrumbs.push({
        title: 'Usage Items',
        link: '',
      });
    }
    return breadcrumbs;
  };

  resetScroll = () => this.props.scrollMainTo(0, 0);

  onCancelClick = () => {
    this.props.history.push('/usage');
  };

  getMainProps = showDirtyConfirm => {
    const { page } = this.state;
    const { fromSite, usageDT, isDisabled, usageItemsInfo } = this.props;
    let toolbox = {
      backButtonProps: { shown: true, path: this.getRootUrl() },
      rightButtons: [],
      shown: true,
    };
    !isDisabled &&
      (toolbox.rightButtons = [
        {
          content: 'Preview Usage Items',
          onClick: this.onPreviewUsageItemsClick,
          disabled:
            fromSite === NewEditUsageEnum.NEW ||
            !usageDT ||
            (!usageItemsInfo || !usageItemsInfo.length),
        },
      ]);
    if (page === 2) {
      delete toolbox.backButtonProps;
      toolbox.rightButtons = [
        {
          content: 'Previous Page',
          onClick: this.previousPage,
        },
        {
          content: 'Save Only',
          onClick: this.handleSaveOnly,
          disabled: !this.isPreviewContainsValidData(),
        },
        {
          content: 'Save Update On Hand and Close',
          onClick: this.handleSave,
          disabled: !this.isPreviewContainsValidData(),
        },
        {
          content: 'Cancel',
          onClick: showDirtyConfirm,
        },
      ];
    }
    return {
      toolbox,
    };
  };

  handleSaveOnly = e => {
    this.props.submitForm(CREATE_EDIT_USAGE_FORM_NAME);
  };

  handleSave = e => {
    this.setState({
      OpType: 'H',
    });
    this.props.submitForm(CREATE_EDIT_USAGE_FORM_NAME);
  };

  isPreviewContainsValidData = () => {
    const { usageItemsInfo } = this.props;
    let data = [];
    if (usageItemsInfo && usageItemsInfo.length) {
      data = usageItemsInfo.filter(item => {
        return item.PriQty || item.SecQty;
      });
    }
    return Boolean(data.length);
  };

  previousPage = () => {
    const {
      usageItemsInfo,
      clearInvalidPreviewData,
      resetFilterOnClickOfPreviousPage,
    } = this.props;
    const data = usageItemsInfo.filter(item => {
      return item.PriQty || item.SecQty;
    });
    clearInvalidPreviewData(data);
    this.setState({ page: this.state.page - 1, resetPageOnDataChange: true });
    resetFilterOnClickOfPreviousPage();
  };

  onPreviewUsageItemsClick = () => {
    const { toSite } = this.props;
    if (toSite === SiteStatusEnum.EMPTY) {
      this.setState({
        showNotificationModal: true,
        message: 'Please select a To Site',
      });
    } else {
      const { history, allTableStates, setTableStates } = this.props;
      clearTableSavedState(history, '', allTableStates, setTableStates, [
        TableNamesEnum.USAGE_LIST_CREATE_EDIT_TABLE,
      ]);
      this.setState({
        page: this.state.page + 1,
        resetPageOnDataChange: true,
      });
    }
  };

  handleSubmit = values => {
    const { UsageId } = this.props.match.params;
    if (moment(values[CreateEditUsageEnum.UsageDT]).isAfter(moment())) {
      this.setState({
        showDeliveryDateModal: true,
        values,
      });
    } else {
      this.props.saveUsage(
        getSaveObject(values, this.state.OpType, UsageId),
        this.resetScroll
      );
    }
  };

  getCreatePageAndPreviewPage = () => {
    const { page } = this.state;
    const { IsNewEdit, UsageId } = this.props.match.params;
    const {
      fetchUsageItems,
      selectedUsageDetail,
      isDisabled,
      usageItemsInfo,
      fetchUsageDetailError,
    } = this.props;
    let element = [];
    let render = false;
    let initialValues = {};
    if (IsNewEdit !== NewEditUsageEnum.NEW) {
      if (selectedUsageDetail) {
        render = true;
        initialValues = {
          [FilterEnum.GroupId_Bid]: 0,
          [FilterEnum.GroupId_Item]: 0,
          [CreateEditUsageEnum.Site]:
            selectedUsageDetail[CreateEditUsageEnum.SiteId],
          [CreateEditUsageEnum.UsageDT]: moment(
            selectedUsageDetail[CreateEditUsageEnum.UsageDT]
          ).format(DATE_FORMAT_FOR_UI),
          [CreateEditUsageEnum.Comments]:
            selectedUsageDetail[CreateEditUsageEnum.Comments],
          [CreateEditUsageEnum.UsageItemsInfo]:
            selectedUsageDetail[CreateEditUsageEnum.UsageItems],
        };
      } else if (fetchUsageDetailError) {
        render = true;
        initialValues = {
          [FilterEnum.GroupId_Bid]: 0,
          [FilterEnum.GroupId_Item]: 0,
          [CreateEditUsageEnum.Site]: SiteStatusEnum.EMPTY,
          [CreateEditUsageEnum.UsageDT]: moment().format(DATE_FORMAT_FOR_UI),
          [CreateEditUsageEnum.Comments]: '',
          [CreateEditUsageEnum.UsageItemsInfo]: [],
        };
      }
    } else {
      render = true;
      initialValues = {
        [FilterEnum.GroupId_Bid]: 0,
        [FilterEnum.GroupId_Item]: 0,
        [CreateEditUsageEnum.Site]: SiteStatusEnum.EMPTY,
        [CreateEditUsageEnum.UsageDT]: moment().format(DATE_FORMAT_FOR_UI),
        [CreateEditUsageEnum.Comments]: '',
        [CreateEditUsageEnum.UsageItemsInfo]: [],
      };
    }
    if (render) {
      page === 1
        ? element.push(
            <CreateEditUsage
              key={`newEdit${page}`}
              initialValues={initialValues}
              IsNewEdit={IsNewEdit}
              fetchUsageItems={fetchUsageItems}
              UsageId={UsageId}
              isDisabled={isDisabled}
              resetPageOnDataChange={this.state.resetPageOnDataChange}
              onResetPageOnDataChange={this.onResetPageOnDataChange}
              setPageResetState={this.setPageResetState}
            />
          )
        : element.push(
            <PreviewUsage
              key={`preview${page}`}
              initialValues={initialValues}
              IsNewEdit={IsNewEdit}
              fetchUsageItems={fetchUsageItems}
              UsageId={UsageId}
              onSubmit={this.handleSubmit}
              usageItemsInfo={usageItemsInfo}
              resetPageOnDataChange={this.state.resetPageOnDataChange}
              onResetPageOnDataChange={this.onResetPageOnDataChange}
            />
          );
    }
    return element;
  };

  getRootUrl = () => {
    return '/usage';
  };

  handleDialog = result => {
    const { UsageId } = this.props.match.params;
    if (result) {
      this.setState({ showDeliveryDateModal: false });
      this.props.saveUsage(
        getSaveObject(this.state.values, this.state.OpType, UsageId),
        this.resetScroll
      );
    } else {
      this.setState({ showDeliveryDateModal: false, OpType: 'S' });
    }
  };
  onResetPageOnDataChange = () => {
    this.setState({ resetPageOnDataChange: false });
  };
  setPageResetState = resetPageOnDataChange => {
    this.setState({ resetPageOnDataChange });
  };

  render() {
    const {
      isReadOnly,
      loading,
      fetchingDropDown,
      submitting,
      fetchingUsageDetail,
    } = this.props;
    return (
      <Fragment>
        {(fetchingDropDown || loading || submitting || fetchingUsageDetail) && (
          <LoadingPage />
        )}
        <Filter title={''} breadcrumbs={this.getBreadCrumbs()} />
        <DirtyWrapper
          closeModalYesCallback={this.onCancelClick}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              {this.getCreatePageAndPreviewPage()}
            </Main>
          )}
        </DirtyWrapper>
        <YesNoDialog
          showDialog={this.state.showDeliveryDateModal}
          title="Inventory"
          question={`Future Usage date entered, are you sure Y/N?`}
          yesCallback={() => {
            this.handleDialog(true);
          }}
          noCallback={() => {
            this.handleDialog(false);
          }}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_USAGE_FORM_NAME);
const mapStateToProps = (state, props) => {
  const { IsNewEdit } = props.match.params;
  const isDisabled =
    Selectors.getSelectedUsageDetail(state) &&
    Selectors.getSelectedUsageDetail(state).Status ===
      StatusOptionEnum.CLOSED &&
    IsNewEdit === NewEditUsageEnum.EDIT;
  return {
    usageItemsInfo: selector(state, [CreateEditUsageEnum.UsageItemsInfo]),
    usageDT: selector(state, [CreateEditUsageEnum.UsageDT]),
    isDisabled: isDisabled,
    allTableStates: getTableStates(state),

    usageItems: Selectors.getUsageItems(state),
    fetchUsageItems: Selectors.getFetchUsageItems(state),
    selectedUsageDetail: Selectors.getSelectedUsageDetail(state),
    fetchingUsageDetail: Selectors.getFetchingUsageDetail(state),
    submitting: Selectors.getSubmitting(state),
    submitted: Selectors.getSubmitted(state),
    submitError: Selectors.getSubmitError(state),
    fetchUsageDetailError: Selectors.getFetchUsageDetailError(state),
    usageItemsLoadingError: Selectors.getUsageItemsLoadingError(state),
    loading:
      FilterSelectors.getBidGroupDataLoading(state) ||
      FilterSelectors.getItemGroupDataLoading(state),
  };
};

const mapDispatchToProps = {
  submitForm,
  resetForm,
  destroyForm,
  saveUsage,
  getUsageDetail,
  getUsageItems,
  emptyItemList,
  emptyEditDulObject,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  clearInvalidPreviewData,
  resetFilterOnClickOfPreviousPage,
  clearOrderSubmitError,
  setTableStates,
  resetDirty,
};
export const CreateUsageWizardForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditUsageWizardForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/containers/subpages/CreateEditUsageWizardForm.js